export default "__VITE_ASSET__BgYTZVLY__"